import { IonSkeletonText } from "@ionic/react";

import loaderStyles from "@components/loaders/LoaderStyles.module.css";
import styles from "@components/messaging/Messages.module.css";

export const ChatsLoader = () => (
  <div className={styles.controlsChats}>
    {Array.from(Array(3)).map(() => (
      <div className={styles.controlsChat} key={Math.random()}>
        <div className={styles.controlsChatHeader}>
          <div className={styles.controlChatUsers}>
            <div className={styles.controlsAvatarsSmall}>
              <IonSkeletonText animated className={loaderStyles.skeletonAvatar30} />
            </div>
            <IonSkeletonText animated className={loaderStyles.skeletonName} />
          </div>
          <IonSkeletonText animated className={loaderStyles.skeletonBodyCopySmall} />
        </div>
        <div className={styles.controlsLastMessage}>
          <IonSkeletonText animated className={loaderStyles.skeletonBodyTwoLines} />
        </div>
      </div>
    ))}
  </div>
);
